export const leaderboardContent = {
  title: "National Leaderboard",
  columns: ["Company Name", "Location", "Status / Score", "First Response"],
  empty: "No companies match this filter.",
  loading: "Loading...",
  speedFilters: [
    { id: "fast", label: "Under 60 seconds" },
    { id: "slow", label: "Over 24 hours" },
  ],
}
